import { useMutation } from '@tanstack/react-query';
import { BusinessDocType } from '../../types';
import { backendServices } from '../../services';

export interface PostDocumentDraftAttachmentsArgs {
    documentId: number;
    businessDocType: BusinessDocType;
    files: File[];
}

export function usePostDocumentDraftAttachments() {
    const mutation = useMutation({
        mutationFn: async (args: PostDocumentDraftAttachmentsArgs) => {
            const api = new backendServices.Apis.DocumentApi();
            const res = await api.postDocumentDraftAttachments(args);
            return res.data;
        },
    });

    return mutation;
}
